import { handleError } from "../../../util/errors";
import apiBase from "../../api";

class TagsService {
  // Get all tags
  fetchTags = async () => {
    try {
      const response = await apiBase.get("/tags");
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error fetching tags");
    }
  };

  // Get single tag with device count
  fetchTag = async (tagId) => {
    try {
      const response = await apiBase.get(`/tags/${tagId}`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error fetching tag");
    }
  };

  // Create tag
  createTag = async (data) => {
    try {
      const response = await apiBase.post("/tags", data);
      if (response.status !== 201 && response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error creating tag");
    }
  };

  // Update tag
  updateTag = async (tagId, data) => {
    try {
      const response = await apiBase.put(`/tags/${tagId}`, data);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error updating tag");
    }
  };

  // Delete tag
  deleteTag = async (tagId) => {
    try {
      const response = await apiBase.delete(`/tags/${tagId}`);
      if (response.status !== 200 && response.status !== 204) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error deleting tag");
    }
  };

  // Set device tags (replaces all)
  setDeviceTags = async (deviceId, tagIds) => {
    try {
      const response = await apiBase.put(`/tags/device/${deviceId}`, { tagIds });
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error setting device tags");
    }
  };

  // Add single tag to device
  addTagToDevice = async (deviceId, tagId) => {
    try {
      const response = await apiBase.post(`/tags/device/${deviceId}/tag/${tagId}`);
      if (response.status !== 200 && response.status !== 201) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error adding tag to device");
    }
  };

  // Remove single tag from device
  removeTagFromDevice = async (deviceId, tagId) => {
    try {
      const response = await apiBase.delete(`/tags/device/${deviceId}/tag/${tagId}`);
      if (response.status !== 200 && response.status !== 204) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error removing tag from device");
    }
  };

  // Bulk assign tag to multiple devices
  bulkAssignTag = async (tagId, fiscalDeviceIds) => {
    try {
      const response = await apiBase.post(`/tags/${tagId}/devices/bulk-assign`, { fiscalDeviceIds });
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error bulk assigning tag");
    }
  };

  // Bulk remove tag from multiple devices
  bulkRemoveTag = async (tagId, fiscalDeviceIds) => {
    try {
      const response = await apiBase.post(`/tags/${tagId}/devices/bulk-remove`, { fiscalDeviceIds });
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error bulk removing tag");
    }
  };

  // Get devices with specific tag
  getDevicesWithTag = async (tagId, page = 1, perPage = 20) => {
    try {
      const response = await apiBase.get(`/tags/${tagId}/devices?page=${page}&perPage=${perPage}`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error fetching devices with tag");
    }
  };
}

export default new TagsService();

